module.exports = __webpack_public_path__ + "img/gift4.54a753cc.png";